import React, { FunctionComponent } from "react";
import { ButtonProps } from "./ButtonShared";

const ButtonTonal = React.forwardRef(
    (
        {
            Base,
            className,
            ...props
        }: {
            Base: FunctionComponent<
                ButtonProps & {
                    buttonClassName?: string;
                    textClassName?: string;
                    iconClassName?: string;
                } & React.ButtonHTMLAttributes<HTMLButtonElement>
            >;
        } & ButtonProps &
            React.ButtonHTMLAttributes<HTMLButtonElement> &
            React.RefAttributes<HTMLButtonElement>,
        forwardedRef: React.Ref<HTMLButtonElement>,
    ) => {
        return (
            <Base
                ref={forwardedRef}
                className={`bg-secondary hover:bg-white active:bg-tertiary border border-secondary ${className}`}
                textClassName={
                    props.disabled ? "text-disabled" : "text-primary"
                }
                iconClassName="text-primary"
                {...props}
            />
        );
    },
);
export default ButtonTonal;
